<!-- @veltra/icons generated sha256:4d8d6103d6221efb gen:8 source:src/svg/normal/form-select.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormSelect' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="M10.5 7.5 12 9l1.5-1.5"
    />
  </svg>
</template>
